import { render, staticRenderFns } from "./LotLink.vue?vue&type=template&id=72db71f3&scoped=true&"
import script from "./LotLink.vue?vue&type=script&lang=js&"
export * from "./LotLink.vue?vue&type=script&lang=js&"
import style0 from "./LotLink.vue?vue&type=style&index=0&id=72db71f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72db71f3",
  null
  
)

export default component.exports